module.exports = __webpack_public_path__ + "img/impi.a47dff17.png";